import { UploadOutlined } from "@ant-design/icons"
import { Typography, Upload, type UploadFile } from "antd"
import { type UploadProps } from "antd/lib/upload"
import React, { useMemo } from "react"

const { Text } = Typography

interface FileUploadProps {
  uploadProps: UploadProps
  files: UploadFile<any>[]
  options: { maxSize: number; extensions: string[] }
}

export function FileUpload({
  uploadProps,
  files,
  options: { maxSize, extensions },
  ...props
}: FileUploadProps) {
  const availableExtensions = useMemo(
    () => extensions?.join(", ")?.toUpperCase() || "",
    [extensions]
  )

  return (
    <Upload.Dragger {...uploadProps} {...props}>
      <p className="ant-upload-drag-icon">
        <UploadOutlined />
      </p>
      <Text>Click or drag files to this area to upload</Text>
      <br />
      <Text type="secondary">{`${availableExtensions} ${maxSize ? `${availableExtensions ? "up to" : ""} ${maxSize}MB each` : ""}`}</Text>
      <br />
      {files?.length > 0 && (
        <Text
          type="secondary"
          strong
          style={{ display: "inline-block", marginTop: "0.5rem" }}
        >
          {files.length} file(s) selected
        </Text>
      )}
    </Upload.Dragger>
  )
}
